<template>
	<div class="evaluate">
		<back-to></back-to>
		<section class="evaluate-content">
			<div class="evaluate-content_img">
				<img :src="param.proImg" alt="">
				<p>{{param.proTitle}}</p>
			</div>
			<div class="evaluate-content_field">
				<van-field v-model="message" rows="5" autosize type="textarea" maxlength="500"
					placeholder="本次旅行满足您的期待吗?说说心得,为其他小伙伴指点迷津吧,注意不要超过500字哦!" show-word-limit />
			</div>
			<div class="evaluate-content_score">
				<label for="" v-for="(item,index) in scoreList" :class="scoreActive == index?'scoreActive':''"
					@click="scoreActive = index">
					<img :src="item.src" alt="">
					<b>{{item.text}}</b>
					<p>{{item.name}}</p>
				</label>
			</div>
		</section>
		<section class="evaluateBottom" @click="submit">
			<label>提交</label>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Dialog,
		Toast
	} from 'vant'
	export default {
		name: 'evaluate',
		components: {
			BackTo
		},
		data() {
			return {
				param: "",
				message: "",
				scoreList: [{
						'src': 'https://m.sweetour.com/img/evaluate/short.png',
						'text': '1分',
						'name': '很差'
					},
					{
						'src': 'https://m.sweetour.com/img/evaluate/dissatisfied.png',
						'text': '2分',
						'name': '不满'
					},
					{
						'src': 'https://m.sweetour.com/img/evaluate/ordinary.png',
						'text': '3分',
						'name': '一般'
					},
					{
						'src': 'https://m.sweetour.com/img/evaluate/may.png',
						'text': '4分',
						'name': '还行'
					},
					{
						'src': 'https://m.sweetour.com/img/evaluate/praise.png',
						'text': '5分',
						'name': '很赞'
					}
				],
				scoreActive: 4
			}
		},
		created() {
			let param = JSON.parse(this.$route.query.dataParam);
			this.param = param
			// console.log(this.param)
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {

		},
		methods: {
			submit() {
				var jsonData = {
					orderId: this.param.orderId, //订单ID
					proid: this.param.proID, //产品ID
					content: this.message, //评价内容
					star: this.scoreActive + 1, //星星      
					score: (this.scoreActive + 1) * 20, //星星*20
					userID: this.userInfo.userId, //用户ID
					typeid: this.param.proTypeID //产品类型
				}
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/AddOrderComment', jsonData
				).then(res => {
					var jsonData = {
						orderID: this.param.orderId
					}
					this.$post(
						this.$apiWebsiteSweet + '/NewOrder/SetOrderStatus', jsonData
					).then(res => {
						this.$router.push({
							path: '/orderStatus',
							query: {
								orderId: this.param.orderId
							}
						})
					})
				})
			}
		}
	}
</script>

<style scoped>
	.evaluate-content {
		width: 100%;
		padding: 30px;
		box-sizing: border-box;
	}

	.evaluate-content_img img {
		width: 207px;
		height: 138px;
		margin-right: 14px;
	}

	.evaluate-content_img {
		font-size: 32px;
		color: #000;
		display: flex;
		align-items: center;
	}

	.evaluate-content_field {
		width: 100%;
		margin-top: 30px;
	}

	.evaluate .van-cell {
		padding: 14px !important;
		background-color: #f2f2f2;
		line-height: 38px;
		font-size: 24px;
	}

	.evaluate-content_score img {
		width: 64px;
		height: 70px;
	}

	.evaluate-content_score {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #f2f2f2;
		margin-top: 30px;
	}

	.evaluate-content_score label {
		width: 20%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 24px;
		color: #666;
		padding: 7px 0;
	}

	.evaluate-content_score b {
		padding: 4px 0;
	}

	.scoreActive {
		background: rgb(251, 176, 59);
	}

	.evaluateBottom {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		background-color: #ff6d00;
		height: 98px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 36px;
		color: #fff;
	}
</style>
